<template>
  <div class="last-box">
    <div class="black-box">
      <p>
        {{ configObj.copyright?.value }}
        <span style="margin: 0px 3px">|</span>
      </p>
      <p>
        <span @click="outUrl" style="cursor: pointer;">{{ configObj.icp?.value }}</span>
        <span style="margin: 0px 3px">|</span>
        {{ configObj.public_security_record?.value }}
      </p>
      <p>网站声明</p>
      <p>技术支持：小牛在线</p>
    </div>
    <div class="white-box">
      <div
        class="navigation-box"
        @click="router.push({ path: '/layout/list/testAndVerify' });drawer2 = false"
      >
        <img src="@/assets/正版验证.png" alt="" />
        <p>正版验证</p>
      </div>
      <div
        class="navigation-box"
        @click="router.push({ path: '/layout/list/bookCorrection' });drawer2 = false"
      >
        <img src="@/assets/物品-书笔.png" alt="" />
        <p>图书反馈</p>
      </div>
      <div class="navigation-box" @click="drawer2 = true">
        <img src="@/assets/商店-选中.png" alt="" />
        <p>官方网店</p>
      </div>
      <div
        class="navigation-box"
        @click="router.push({ path: '/layout/list/personalCenter' });drawer2 = false"
      >
        <img src="@/assets/我 的.png" alt="" />
        <p>我的</p>
      </div>
    </div>

    <el-drawer
      v-model="drawer2"
      direction="btt"
      :append-to-body="false"
      class="my-drawer"
    >
      <!-- <template #header>
        <h4>set title by slot</h4>
      </template> -->
      <template #default>
        <!-- <div>
          <h1>这是网上店铺</h1>
        </div> -->

        <div class="store-box">
          <div
            class="item"
            v-for="(item, index) in mydata.storeArr"
            :key="index"
            @click="storeItemClick(item)"
          >
            <img v-complete:src="item.image" style="border-radius: 8px" />
            <p>{{ item.platform }}</p>
          </div>
        </div>
      </template>
    </el-drawer>
  </div>
</template>

<script setup>
import { useRouter, useRoute } from "vue-router";
import { inject, ref, reactive } from "vue";

import { configFloating } from "@/api/home/index.js";

const router = useRouter();
const route = useRoute();
const configObj = inject("configObj");

const drawer2 = ref(false);

const mydata = reactive({
  customerObj: {},
  storeArr: [],
  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
});

function getData() {
  configFloating().then((res) => {
    mydata.customerObj = res.data.service_qrcode;
    mydata.storeArr = res.data.direct_store;
  });
}

getData();

// 官网网店的每个网店的点击事件
function storeItemClick(item) {
  window.open(item.url);
}


//跳到外部链接
function outUrl(){
  window.open("https://beian.miit.gov.cn")
  
}







</script>

<style scoped lang="scss">
.last-box {
  width: 375px;
  //   border: 1px solid red;
  overflow: hidden;
  margin: 0 auto;

  //黑色
  .black-box {
    height: 95px;
    background-color: #171717;
    overflow: hidden;
    margin: 0 auto;
    margin-bottom: 95px;
    p {
      font-size: 12px;
      font-weight: 400;
      color: #737070;
      line-height: 20px;
      text-align: center;
    }
    p:first-of-type {
      margin-top: 9px;
    }
  }

  //白色
  .white-box {
    width: 375px;
    height: 95px;
    background-color: #ffffff;
    display: flex;
    justify-content: space-around;
    border-top: 1px solid #d9d6d649;

    position: fixed;
    bottom: 0;
    // left: 0;
    // width: 100%; /* 确保元素宽度占满整个视口 */
    background-color: #f8f9fa; /* 背景颜色，根据需要设置 */
    z-index: 999999999;
    margin: 0 auto;
    overflow: hidden;
    /* 其他样式 */

    .navigation-box {
      width: 40px;
      height: 40px;
      margin-top: 10px;
      // border:1px solid red;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      img {
        width: 24px;
        height: 24px;
      }
      p {
        font-size: 10px;
        font-weight: 400;
        color: #4e5969;
      }
    }
  }

  :deep(.el-drawer.btt.open) {
    width: 375px;
    margin-bottom: 95px;
    border-radius: 12px 12px 0px 0px;
    .el-drawer__header {
      margin-bottom: 0px;
    }
  }
  :deep(.my-drawer) {
    // border: 1px solid red;
    margin: 0 auto;
    width: 375px !important;
  }

  :deep(.my-drawer.el-drawer.btt.open){
    height:25% !important;
  }

  // 官方网店
  .store-box {
    display:flex;
    //justify-content: space-between;
    > .item {
      // width: 150px;
      // height: 150px;
      // border: 1px solid blue;
      // margin-bottom: 20px;
      margin-right: 20px;
      > img {
        display: block;
        width: 50px;
        // height: 80px;
        margin: 0 auto;
      }
      > p {
        // border: 1px solid rgb(208, 255, 192);
        text-align: center;
        // font-size: 16px;
        font-size: 14px;
        font-weight: bold;
        margin-top: 5px;
      }
    }
  }
}
</style>